<template>
    <div class="cart-container">
        <div class="alert alert-danger alert-dismissible" v-if="isItemUpdated">
            <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="confirmCartChangeUpdate">&times;</a>
            Die Lagermenge der Artikel im Warenkorb hat sich geändert, bitte kontrollieren Sie den Warenkorb!
        </div>
        <div class="alert alert-danger alert-dismissible" v-if="removedItems.length > 0">
            <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="confirmCartChangeRemove">&times;</a>
            Folgende Produkte wurden auf Grund von geänderter Lagermenge aus dem Warenkorb entfernt:
            <ul>
                <li v-for="removedItem in removedItems">{{removedItem.name}}</li>
            </ul>
        </div>
        <div class="row" v-if="empty">
            <div class="col-sm-12 text-center">
                Warenkorb ist leer.
            </div>
        </div>
        <table class="table table-xs" v-else>
            <tbody>
            <tr>
                <th v-if="!readonly">Löschen</th>
                <th></th>
                <th>Artikelnummer</th>
                <th>Produktbezeichnung</th>
                <th class="text-right">Preis/Stück</th>
                <th class="text-right">Menge/Stück</th>
                <th class="text-right">Zwischensumme</th>
            </tr>
            <tr v-if="loadingCart">
                <td colspan="8" align="center"><i class="fa fa-spin fa-spinner"></i></td>
            </tr>
            <cart-row v-for="item in items" :key="item.rowId" :item="item" :value="item.qty" :stock="item.pstock" :readonly="readonly"></cart-row>
            <cart-row-charge v-for="charge in chargeItems" :key="charge.rowId" :item="charge" :readonly="readonly"></cart-row-charge>
            <tr class="item-row">
                <td class="delete" v-if="!readonly"></td>
                <td></td>
                <td></td>
                <td>Versandkosten</td>
                <td class="text-right"></td>
                <td class="text-right"></td>
                <td class="text-right" title="Subtotal">€ {{ shippingCost }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<style lang="scss">
    .cart-container {
        .alert:first-child {
            margin-top: 15px;
        }
    }
</style>

<script>
export default {
  
    props: {
        readonly: {
            default: false
        },
        comment: {
            default: ''
        },
        instance: {
            default: 'default'
        }
    },

    data() {
            return {
                loading: false,
                loadingCart: true,
                initialized: false,
                userComment: '',
                voucherCode: '',
                voucherCodeError: "",
                voucherValue: 0,
                items: {},
                chargeItems: {},
                freeItems: {},
                removedItems: [],
                isItemUpdated: false,
                data: {
                    tax: '0',
                    total: '0',
                    shippingCost: '0',
                    shippingCostNumber: '0',
                    voucher: "",
                    subtotal: '0',
                    subtotalVat: '0',
                    discountValueForProducts: '0',
                    discountValue: '0',
                    fullPrice: '0',
                    orderValue: '0'
                }
            }
    },

    created() {
        new Form({instance:this.instance}).post('/api/cart/content')
            .then((response) => {
                this.items = response.items;
                this.chargeItems = response.chargeItems;
                this.freeItems = response.freeItems;
                this.data  = response.data;
                this.isItemUpdated = response.isItemUpdated;
                this.removedItems = response.removedItems;
                this.voucherCode  = response.data.voucher.code;
                this.voucherValue  = response.data.voucher.discount_value;
                this.initialized = true;
                this.$emit('onLoad', this.items);
                this.loadingCart = false;
            });

        App.event.listen('cart.updated', (response) => {
            this.items = response.items,
            this.freeItems = response.freeItems;
            this.data = response.data;
            this.voucherCode  = response.data.voucher.code;
            this.voucherValue  = response.data.voucher.discount_value;
        });
    },

    methods: {
        confirmCartChangeUpdate() {
            new Form({instance:this.instance}).post('/api/cart/confirmCartChangeUpdate');
        },
        confirmCartChangeRemove() {
            new Form({instance:this.instance}).post('/api/cart/confirmCartChangeRemove');
        }
    },

    computed: {

        subtotal() {
            return parseFloat(this.data.fullPrice).toFixed(2).replace('.', ',');
        },

        tax() {
            this.data.tax = (this.data.fullPrice*1.19)-(this.data.fullPrice);
            return parseFloat(this.data.tax).toFixed(2).replace('.', ',');
        },

        orderValue() {
            this.data.orderValue = parseFloat(this.data.total) - parseFloat(this.data.shippingCost);
            return parseFloat(this.data.orderValue).toFixed(2);
        },

        subtotalVat() {
            this.data.subtotalVat = parseFloat(this.data.fullPrice) + parseFloat(this.data.tax) - parseFloat(this.data.discountValue);
            if(this.data.subtotalVat < 0) {
                this.data.subtotalVat = 0;
            }
            return parseFloat(this.data.subtotalVat).toFixed(2).replace('.', ',');
        },

        discountValueForProducts() {        
            this.data.discountValueForProducts = parseFloat(this.data.fullPrice) - parseFloat(this.data.subtotal);
            this.data.discountValueForProducts = parseFloat(this.data.discountValueForProducts).toFixed(2)*1.19;
            return parseFloat(this.data.discountValueForProducts).toFixed(2).replace('.', ',');
        },

        discountValue() {        
            this.data.discountValue = parseFloat(this.data.fullPrice) - parseFloat(this.data.subtotal);
            this.data.discountValue = parseFloat(this.data.discountValue).toFixed(2)*1.19;
            this.data.discountValue = parseFloat(this.data.discountValue) + parseFloat(this.voucherValue);
            return parseFloat(this.data.discountValue).toFixed(2).replace('.', ',');
        },

        shippingCost() {
            if(this.data.shippingCost != 0) {
                return this.data.shippingCost.toFixed(2).replace('.', ',');
            } else {
                return 0;
            }
            
        },
        shippingCostNumber() {
            return this.data.shippingCost;            
        },

        total() { 
            this.data.total = parseFloat(this.data.subtotalVat)+parseFloat(this.data.shippingCost);
            
            return parseFloat(this.data.total).toFixed(2).replace('.', ',');
        },

        link() {
            return App.url;
        },

        empty() {
            return this.initialized && Object.keys(this.items).length === 0;
        },

        totalsSpan() {
            return this.readonly ? 1 : 2;
        }
    }
}
</script>
